jQuery(function () {
  // Sustituye a javascript:void(0) - No SEO friendly
  $('.no-action').on('click', function (e) {
    e.preventDefault();
  });

  //Quitar el prehead de las alertas
  $('.prehead-alertas .cerrar').click(function () {
      var preheadAlertas = $('.prehead-alertas');
      preheadAlertas.fadeOut();
      $('.headerPagina ').addClass('sin-banner');
      jQuery.ajax({
        type: 'POST',
        async: true,
        url: rutajs + 'lib/ajax.php',
        data: 'fn=setSessionBanner',
        success: function (data) {
          preheadAlertas.remove();
        },
      });
  });

  //Menú lateral móvil
  let menuAbierto = false;
  $('.menu-movil').click(function () {
    $('.nav-menu').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('no-scroll');
    menuAbierto = !menuAbierto;
  });

  //Menú desplegable móvil
  $('.caret-sm').each(function () {
    $(this).click(function () {
      $(this).next().slideToggle();
      $(this).toggleClass('open');
    });
  });

  //Función para esconder el buscador en móvil
  function buscadorMovilOculto() {
    scroll = $(window).scrollTop();
    if (scroll >= 80 && $(window).width() < 1025) {
      $('.buscador-principal').slideUp('fast');
    } else if (scroll == 0 && $(window).width() < 1025) {
      $('.buscador-principal').slideDown('fast');
    }
  }
  $(window).scroll(function () {
    buscadorMovilOculto();
  });

// Función para el Tooltip
$('body').find('.a-tooltip').each(function () {
  let puntero = $(this);
  let offsetPuntero = puntero.offset();
  let textTooltip = puntero.data('tooltip');
  let tooltip = $('.text-tooltip');

  puntero.mouseover(function (e) {
    if (!puntero.hasClass('disable-tooltip')) {
      tooltip.show().html(textTooltip);
      let anchuraTooltip = tooltip.innerWidth();
      let alturaTooltip = tooltip.innerHeight();
      tooltip.css({
        left: offsetPuntero.left - anchuraTooltip / 2 + 10,
        top: offsetPuntero.top - alturaTooltip - 10,
      });
    }
  });

  puntero.mouseout(function () {
    tooltip.hide();
  });
});

// Enseña y oculta elementos del footer
$('.toggle').on('click', '.caret', function () {
  $(this).parent().next().slideToggle();
  $(this).toggleClass('open');
});

  //Funcion modal
  let modalOpen = false;
  $('body')
    .find('.btn-modal')
    .each(function () {
      let modal = $(this).attr('href');
      $(this).click(function () {
        // este if es porque el modal-filtros-avanzados antes de abrirse tiene que comprobar si tiene los datos que necesita.
        // Asi que abrimos el modal solo si no es ese modal (x ejemplo el de alertas) o ya tenemos los datos que necesita el modal filtros avanzados. Si no es asi, se abre desde la funcion mostrarSpinnerMientrasCarganFiltros()
        if (
          modal != '#modal-filtros-avanzados' ||
          $('#contenido-busqueda-avanzada').children().length > 0
        ) {
          anadirScriptBuscadorAvanzado();
          $(modal).fadeIn();
          $(modal).addClass('open');
          modalOpen = true;
          if (!menuAbierto) {
            $('body').addClass('no-scroll');
          }
        }
      });
    });
  // cuando pulsas cerrar modal filtros

    $('.modal-opobusca').on('click', '.close-modal, .modal-close', function () {
      $(this).closest('.modal-opobusca').fadeOut().removeClass('open');
      $('script[data-script="buscador"]').remove();
      modalOpen = false;
      if (!menuAbierto) {
        $('body').removeClass('no-scroll');
      }
    });

    // esto habra que revisarlo. porque tambien se tendría que quitar pulsando fuera del modal
  $(document).on('click', '.cm-form-close', function () {
    $('.modal-cupon-opobusca').removeClass('open');
    $('body').removeClass('no-scroll');
    modalOpen = false;


    // esto se hace desde el comun
    // if(document.getElementsByClassName('grecaptcha-badge')[0])
    //   $('.grecaptcha-badge').remove();

    setTimeout(function () {
      $('#modal-cupon').remove();
      $('link[title=cssModalCuponCustom]')[0].remove();
      // $('#btnCustomInfoGeneralCupon.movil').fadeIn();
    }, 350);
  });



  //Listado a dos columnas en escritorio (repetir labels en las dos columnas)
  let listadoDosColumnas = $('.listado-oposiciones.two-column');
  let liLabelsListado = $(listadoDosColumnas).find('.li-labels-listado');
  let labelsListado = $(liLabelsListado).find('.labels-listado');
  $(labelsListado).clone().appendTo(liLabelsListado);
  $(liLabelsListado).addClass('two-labels');

  //Función reordenar listas (TENIA LUGAR CUANDO LAS DOS FLECHAS ERAN UN SOLO BOTON)
  // $('.labels-listado').each(function () {
  //   $(this)
  //     .find('.ordenar-listado')
  //     .click(function () {
  //       // console.log($(this));
  //       $(this)
  //         .parent()
  //         .parent()
  //         .find('.active')
  //         .not(this)
  //         .removeClass(['active', 'ascendente', 'descendente']);
  //       $(this).addClass('active');

  //       if (
  //         !$(this).hasClass('ascendente') &&
  //         !$(this).hasClass('descendente')
  //       ) {
  //         $(this).addClass('ascendente');
  //       } else {
  //         $(this).toggleClass('ascendente descendente');
  //       }
  //     });
  // });

  //Función para las tabs (SE QUEDA ASI POR SI NECESITAMOS TABS EN ALGUN MOMENTO)
  // $('.tabs-convocatorias').find('.btn').each(function(){
  //     $(this).click(function () {
  //         let txt = $(this).attr('data-txt');
  //         let tab = $(this).attr('href');
  //         $('.tabs-convocatorias .btn').removeClass('active');
  //         $('.tabs-content').removeClass('active');
  //         $(tab).addClass('active');
  //         $(this).addClass('active');
  //         $('.txt-convocatoria').html(txt);
  //         $('html, body').animate({ scrollTop: 0} );
  //     });
  // });

  //Filtrar los checks dentro del buscador del modal

  $('#frmCupon').on('change keypress textInput input', function (){
    if (v_unica_start == 1)
      enviarEventoFormulario(2);
    v_unica_start = 2;
  });

  $('#form_cupon_idcurso').on('change', function() {
    var valorGrupo = $(this).find('option:selected').data('grupo');
    $('#form_cupon_categoria').val(valorGrupo);
  });
});
// HASTA AQUI jQuery(function)....

// ponemos aqui esta funcion para que se pueda usar en varios sitios
function normalizeTildes(string) {
  // utilizamos esta funcion con el texto que metemos en el input, y con el que evaluamos.
  // con el .map() hacemos iterar el string letra por letra
  // con el join del final las agrupamos de nuevo en una palabra
  const vocalTable = {
    á: 'a',
    é: 'e',
    í: 'i',
    ó: 'o',
    ú: 'u',
  };

  return Array.from(string)
    .map((letter) => vocalTable[letter] || letter)
    .join('');
}

//Función para el modal de alertas
function avisosMailing(sEmail) {
  if (typeof sEmail === 'undefined') {
    sEmail = '';
  }
  jQuery.ajax({
    type: 'POST',
    async: true,
    url: rutajs + 'lib/ajax.php',
    data: 'fn=showAlert&sEmail=' + sEmail,
    success: function (data) {
      $('body').append(
        "<script src='/web/js/dist/m-select-d-box.min.js?r=" +
          cdn_v +
          "' title='jsType'></script>"
      );
      $('body').append(
        "<script title='script-alertas' src='" +
          rutaweb +
          "/web/js/dist/modal-alertas.min.js?v=" +
          cdn_v +
          "'></script>"
      );
      $('#container-alertas').html(data);

      $('#modal-alertas').fadeIn();
      $('#modal-alertas').addClass('open');
      $('body').addClass('no-scroll');
    },
  });
}

$('.modal-alertas-opobusca')
  .find('.close-modal')
  .click(function () {
    $('#container-alertas').empty();
    if (
      typeof $('script[title=jsType]')[0] != 'undefined' &&
      $('script[title=jsType]')[0] !== null
    )
      $('script[title=jsType]')[0].remove();
    if (
      typeof $('script[title=script-alertas]')[0] != 'undefined' &&
      $('script[title=script-alertas]')[0] !== null
    )
      $('script[title=script-alertas]')[0].remove();
    if (
      typeof $('[class *= m-select-d-box]') != 'undefined' &&
      $('[class *= m-select-d-box]') !== null
    )
      $('[class *= m-select-d-box]').remove();
    if (
      typeof $('[id *= m-select-d-box]') != 'undefined' &&
      $('[id *= m-select-d-box]') !== null
    )
      $('[id *= m-select-d-box]').remove();
    $('.modal-alertas-opobusca').fadeOut();
    $('.modal-alertas-opobusca').removeClass('open');
    $('body').removeClass('no-scroll');
  });

function lanzarBusqueda(formularioAvanzado) {
  var busqueda = $.trim($('#search-index-input').val());
  var busquedaMobile = $.trim($('#search-index-input-mobile').val());

  // este es para conservar el anterior valor del input text
  var busquedaHidden = $.trim($('#search-index-input-hidden').val());
  var tipoListado = '';

  if (busqueda == busquedaHidden && busquedaMobile != '') {
    busqueda = busquedaMobile;
  }

  busqueda = sustituciones(busqueda);

  // if($('#search-index-input').val() != ''){
  //     $('#search-index-input').val(busqueda);
  // }
  // if($('#search-index-input-mobile').val() != ''){
  //     $('#search-index-input-mobile').val(busqueda);
  // }

  // si estamos en la pagina de resultados
  if ($('#tipo_listado').length > 0) {
    tipoListado = $('#tipo_listado').val();
  } else {
    tipoListado = 'oposiciones';
  }
  var isValid = false;
  if (formularioAvanzado == 1) {
    let checkeados = $('.input-avanzado:checked').length;

    if (checkeados > 0 || !empty(busqueda)) {
      isValid = true;
    }

    // si venimos desde el boton borrar filtros
    if ($('#borrar-filtros').length > 0) {
      isValid = true;
    }

    // si venimos de resetear filtros
    if ($('#resetear-filtros').length > 0) {
      // alert("se supone que ha añadido el campo");
      isValid = true;
    }

    if (isValid === false) {
      alert('Tienes que rellenar alguno de los campos');
      return false;
    }
  }

  // tenemos que construir la url dependiendo de de que pagina vengamos

  if (!empty(busqueda) || (formularioAvanzado == 1 && isValid === true)) {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data: 'fn=getUrlAmigable&query=' + busqueda,
      success: function (busquedaAmigable) {
        // if(formularioAvanzado == 1 && busquedaAmigable===''){busquedaAmigable = 'avanzada'}

        // alert("bAmigable "+busquedaAmigable);

        if (!empty(busqueda)) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'buscador',
            query: htmlspecialchars(busqueda), // Esta variable recogerá la concatenación de lo que el usuario ha utilizado como filtro del buscador.
          });
        }

        if (formularioAvanzado == 1) {
          // alert("entra en avanzado");
          $('#busqueda-avanzada').attr(
            'action',
            rutajs +
              'busqueda/' +
              tipoListado +
              (busquedaAmigable !== '' ? '/' + busquedaAmigable : '')
          );
        } else if (formularioAvanzado == 2) {
          // solo para el buscador simple de dentro del nav
          $('#busqueda-mobile').attr(
            'action',
            rutajs +
              'busqueda/' +
              tipoListado +
              (busquedaAmigable !== '' ? '/' + busquedaAmigable : '')
          );
        } else {
          // alert("entra en normal "+rutajs+'busqueda/'+tipoListado+'/'+busquedaAmigable);
          $('#busqueda').attr(
            'action',
            rutajs +
              'busqueda/' +
              tipoListado +
              (busquedaAmigable !== '' ? '/' + busquedaAmigable : '')
          );
        }
      },
    });
    return true;
  } else {
    alert('La búsqueda no puede estar vacía');
    return false;
  }
}

$('.envia-formulario-avanzado').click(function () {
  $('#busqueda-avanzada').submit();
});


$('#search-index-input').keydown(function (e) {
  // Capturamos qué telca ha sido
  var keyCode = e.which;
  // Si la tecla es el Intro/Enter
  if (keyCode == 13) {
    // si ocurre esto, por defecto se hace el submit del form id="busqueda".
    // simulamos el click para que se ejecute el busqueda avanzada, y devolvemos false para que no se ejecute el otro.
    if ($('#btn-search-sm').length > 0) {
      $('#btn-search-sm').click();
      e.preventDefault();
      return false;
    }
  }
});

function sustituciones(busqueda) {
  // alert("sustituciones");
  const oposicionesAredirigir = {
    'Policías Nacionales': 'Policía Nacional',
    'Guardias Civiles': 'Guardia Civil',
    'Guardia Civiles': 'Guardia Civil',
    Administrativos: 'Administrativo',
    'Auxiliares Administrativos': 'Auxiliar Administrativo',
    Ejército: 'Tropa y Marinería',
    Tropa: 'Tropa y Marinería',
    Militar: 'Tropa y Marinería',
    Militares: 'Tropa y Marinería',
    'Policías Locales': 'Policía Local',
    Enfermeros: 'Enfermería',
    Enfermeras: 'Enfermería',
    'Auxilios Judiciales': 'Auxilio Judicial',
    'Gestores Procesales': 'Gestión Procesal y Administrativa',
    'Tramitadores Procesales': 'Tramitación Procesal y Administrativa',
    Ertzaina: 'Ertzaintza',
    Ertzainas: 'Ertzaintza',
    'Agents Rurals': 'Agent Rural',
    'Agentes Rurales': 'Agent Rural',
    Celadores: 'Celador Sanitario',
    'Agentes Tributarios Locales': 'Agente Tributario Local',
    'Auxiliares Banco de España': 'Auxiliar Banco de España',
    'Auxiliares Tributarios': 'Auxiliar Tributario',
    'Controladores Aereos': 'Controlador Aereo',
    'Educadores Sociales': 'Educacion Social',
    'Educadores Infantiles': 'Educación Infantil',
    'Guardias Urbanos': 'Guardia Urbana',
    'Maestra Primaria': 'Maestros Educación Primaria',
    'Maestras Primaria': 'Maestros Educación Primaria',
    'Maestro Primaria': 'Maestros Educación Primaria',
    'Maestros Primaria': 'Maestros Educación Primaria',
    'Oficiales Tributarios Locales': 'Oficial Tributario Local',
    'Operadores Comerciales': 'Operador Comercial',
    'Policias Forales': 'Policía Foral',
    'Policias Municipales Madrid': 'Policia Municipal de Madrid',
  };

  for (var clave in oposicionesAredirigir) {
    // si coincide alguna clave (convertida en minusculas)
    if (
      normalizeTildes($.trim(busqueda).toLowerCase()) ==
      normalizeTildes(clave.toLowerCase())
    ) {
      // Esto se queda comentado porque si no cambiaba la palabra antes de recargar la pagina y quedaba raro

      // if($('#search-index-input').val() != ''){
      //     $('#search-index-input').val(oposicionesAredirigir[clave].toLowerCase());
      // }
      // if($('#search-index-input-mobile').val() != ''){
      //     $('#search-index-input-mobile').val(oposicionesAredirigir[clave].toLowerCase());
      // }

      $('#search-index-input-hidden').val(
        oposicionesAredirigir[clave].toLowerCase()
      );
      return oposicionesAredirigir[clave];
    }
  }
  return busqueda;
}



function goTo(id) {
  $('html, body').animate({ scrollTop: $('#' + id).offset().top }, 2000);

  if (!empty(errorForm))
    enviarEventoFormulario(4);
}

// PENDIENTE DE SABER SI SE USA
function empty(mixed_var) {
  //  discuss at: http://phpjs.org/functions/empty/
  // original by: Philippe Baumann
  //    input by: Onno Marsman
  //    input by: LH
  //    input by: Stoyan Kyosev (http://www.svest.org/)
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Onno Marsman
  // improved by: Francesco
  // improved by: Marc Jansen
  // improved by: Rafal Kukawski
  //   example 1: empty(null);
  //   returns 1: true
  //   example 2: empty(undefined);
  //   returns 2: true
  //   example 3: empty([]);
  //   returns 3: true
  //   example 4: empty({});
  //   returns 4: true
  //   example 5: empty({'aFunc' : function () { alert('humpty'); } });
  //   returns 5: false

  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, '', '0'];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === 'object') {
    for (key in mixed_var) {
      // TODO: should we check for own properties only?
      //if (mixed_var.hasOwnProperty(key)) {
      return false;
      //}
    }
    return true;
  }

  return false;
}

function getComboMD(tipo, required, padre, clase) {
  clase = !empty(clase) ? clase : 'form-control';

  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + 'lib/ajax.php',
    data:
      'fn=getComboMD&tipo=' +
      tipo +
      '&required=' +
      required +
      '&padre=' +
      padre +
      '&class=' +
      clase,
    success: function (data) {
      jQuery('#cont-' + tipo).html(data);
    },
  });
}

function setForwardUrl(idForm = "form_cupon", iframe = false) {
  var codcurso = $('#' + idForm + ' #form_cupon_idcurso').val();
  var telefono = $('#' + idForm + ' #form_cupon_cupon_telefono').val();

  if (compruebaTelefonoCaracteres(idForm, 'form_cupon_cupon_telefono'))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $("#" + idForm + " #btnInformacion").attr("disabled", true);
  $("#" + idForm + " #btnInformacion").html(htmlSpinner);

  $("#" + idForm + " #forward_url").val(
    rutaweb +
      rutajs +
      'opobuscaweb/sended-cupon.action?codigoCurso=' +
      codcurso +
      '&telefono=' +
      telefono
  );

  enviarEventoFormulario(0, "#" + idForm + " ");
  enviarEventoFormulario(3, "#" + idForm + " ");
  return true;
}

function validateForm(validateChecks) {
  // This function deals with validation of the form fields
  var x,
    y,
    i,
    valid = true;
  x = document.getElementsByClassName('validate-from');
  y = x[0].getElementsByTagName('input');

  var numberChecks = $('input[name="cursos[]"]:checked').length;

  if (numberChecks == 0 && validateChecks) {
    valid = false;
    alert('Selecciona al menos una oposición');
  } else {
    // A loop that checks every input field in the current tab:
    for (i = y.length - 1; i > 0; i--) {
      if (!y[i].checkValidity()) {
        // Show errors
        y[i].reportValidity();
        // and set the current valid status to false
        valid = false;
      }
    }

    z = x[0].getElementsByTagName('select');
    // A loop that checks every select field in the current tab:
    for (i = 0; i < z.length; i++) {
      if (!z[i].checkValidity()) {
        // Show errors
        z[i].reportValidity();
        // and set the current valid status to false
        valid = false;
      }
    }
  }

  return valid; // return the valid status
}



// NOTA IPN: tambien creo que solo se usa en el index
function altaMailing(sCode) {
  if (typeof sCode === 'undefined') {
    sCode = '';
  }
  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + 'lib/ajax.php',
    data: 'fn=showAlert&sCode=' + sCode,
    success: function (data) {
      if (!document.querySelector("[title='script-alertas']")) {
        $('body').append(
          "<script title='script-alertas' src='" +
            rutaweb +
            "/web/js/dist/modal-alertas.min.js?v=" +
            cdn_v +
            "'></script>"
        );
      }
      $('#container-alertas').html(data);

      $('#modal-alertas').fadeIn();
      $('#modal-alertas').addClass('open');
      $('body').addClass('no-scroll');
    },
  });
}

function cargarChecksModal(pagina) {
  // estas variables las creamos en el config.php
  // las que vienen por POST las seteamos en el config
  // las que vienen por GET las setteamos en el resultados.php
  // vienen por post cuando son varios filtros o NO TIENE pagina de tematica concreta x.ej
  // convocatorias/capacitacion-profesional-transportista
  // convocatorias/almeria
  // vienen por GET cuando si tienen pagina concreta

  if (getAutonomias !== null) {
    postAutonomias = getAutonomias;
  }

  if (getProvincias !== null) {
    postProvincias = getProvincias;
  }

  if (getConvocantes !== null) {
    postConvocantes = getConvocantes;
  }

  if (getOposiciones !== null) {
    postOposiciones = getOposiciones;
  }

  if (getGrupoOposicion !== null) {
    postGrupoOposicion = getGrupoOposicion;
  }

  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + 'lib/ajax.php',
    data:
      'fn=getCheksModal&oposiciones=' +
      JSON.stringify(postOposiciones) +
      '&autonomia=' +
      JSON.stringify(postAutonomias) +
      '&provincia=' +
      JSON.stringify(postProvincias) +
      '&convocante=' +
      JSON.stringify(postConvocantes) +
      '&categoria-filtro=' +
      JSON.stringify(postCategorias) +
      '&grupo-oposicion=' +
      JSON.stringify(postGrupoOposicion)+ 
      '&pagina='+pagina,
    success: function (data) {
      $('#contenido-busqueda-avanzada').html(data);
    },
  });
}

function mostrarSpinnerMientrasCarganFiltros(filtro) {
  let elementoActivo = '';
  let modalOpen = false;

  let filtros = [
    'oposiciones',
    'autonomia',
    'provincia',
    'convocante',
    'categoria',
    'grupo-oposicion',
  ];

  filtros.forEach(function (elemento, indice, array) {
    // console.log(elemento, indice);
    if (filtro.hasClass('a-filtro-busqueda-' + elemento)) {
      elementoActivo = $('.a-filtro-' + elemento);
    }
  });

  if (elementoActivo == '') {
    elementoActivo = $('.a-filtro-oposiciones');
  }

  var intervalo = setInterval(function () {
    if ($('#contenido-busqueda-avanzada').children().length > 0) {
      setTimeout(function () {
        // console.log("ya se ha cargado");
        elementoActivo.addClass('active');
        // Simulamos el click en la pestana activa, xq eso es lo que hace que se anada la clase visible al formulario (sin el setTimeout no va bien la simulacion del onclick)
        elementoActivo.click();
        $('#modal-filtros-avanzados').fadeIn();
        $('#modal-filtros-avanzados').addClass('open');
        anadirScriptBuscadorAvanzado();
        $('#modal-filtros-avanzados').css('display', 'block');
        $('body').addClass('no-scroll');
        modalOpen = true;
      }, 300);
      if (modalOpen) {
        clearInterval(intervalo);
        // $('.spinner-contenedor').fadeOut();
        mostrarOcultarSpinner(false, 'body');
      }
    }
  }, 300);

  if ($('#contenido-busqueda-avanzada').children().length == 0) {
    mostrarOcultarSpinner(true, 'body');
  }
}

function anadirScriptBuscadorAvanzado() {
  if ($('script[data-script="buscador"]').length === 0) {
    // Si no existe, agregar el script dinámicamente
    $('body').append(
      "<script data-script='buscador' src='" +
        rutaweb +
        "/web/js/dist/script-buscador-avanzado.min.js?v="+cdn_v+"'></script>"
    );
  }
}

$('.a-filtro-avanzado, .a-filtro-busqueda').click(function () {
  let botonPulsado = $(this);

  mostrarSpinnerMientrasCarganFiltros(botonPulsado);
});

// el DOM reconoce cuando ha habido algun cambio y oculta el spinner
// $('#contenido-busqueda-avanzada').on('DOMSubtreeModified', function () {
//   if ($('#contenido-busqueda-avanzada').children().length > 0) {
//     $('.spinner-contenedor').fadeOut();
//   }
// });

// Seleccionar el elemento que se desea observar
// var contenidoBusqueda = document.getElementById('contenido-busqueda-avanzada');

// // Crear un nuevo observador de mutaciones
// var observer = new MutationObserver(function(mutations) {
//   // Por cada mutación detectada, verificar si hay elementos hijos
//   mutations.forEach(function(mutation) {
//     if (mutation.addedNodes.length > 0) {
//       // Si se agregaron elementos hijos, ocultar el spinner
//       $('.spinner-contenedor').fadeOut();
//     }
//   });
// });

// // Opciones para el observador (observar cambios en los hijos y sus atributos)
// var config = { childList: true, subtree: true };

// // Comenzar a observar el elemento objetivo
// observer.observe(contenidoBusqueda, config);

function enviarEvento(idForm = "#form_cupon ") {
  var valorTipo = 'oposicion';

  // creo que no hay iGrupo
  var valorCategoria = $(idForm + ' #iGrupo option:selected').html();
  var valorCurso = $(idForm + ' #form_cupon_idcurso option:selected').html();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'form_send',
    step: '1',
    formacion: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
    categoria: valorCategoria, // Aquí la categoría de la elección anterior.
    curso: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  });

  enviarEventoFormulario(2, idForm);
}

function enviarEventoFormulario(tipoEvento = 0, idForm = "#form_cupon ") {
  var valorTipo = 'oposicion'; // Siempre será oposición
  var v_form_subcategory = 'undefined';

  var valorTipoCupon = $(idForm + ' #tipo_cupon').val();
  if (typeof valorTipoCupon === 'undefined') {
      var valorTipoCupon = 'PDP';
  }

  // var valorCategoria = $('#iGrupo option:selected').html(); // Este valor está en el cupón del modal
  var valorCategoria = v_form_category = $(idForm + ' #CategoriaCuponGeneral option:selected').html();
  if (typeof valorCategoria === 'undefined') {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCategoria = v_form_category = $(idForm + ' #form_cupon_categoria').val();
    if (typeof valorCategoria === 'undefined') {
      // Si estoy en un listado lo cojo del select del curso
      var valorCategoria = v_form_category = $(idForm + ' #form_cupon_idcurso option:selected').attr(
        'data-categoria'
      );
    }
  }
  var valorCurso = $(idForm + ' #form_cupon_idcurso option:selected').html();
 
  if (typeof valorCurso === 'undefined') {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCurso = $(idForm + ' #form_cupon_sCurso').val();
  }
  var valorPais = '';
  var valorProvincia = $(idForm + ' #provinciaid option:selected').html();
  var valorCP = $(idForm + ' #form_cupon_cupon_codigopostal').val();
  var valorNacionalidad = $(idForm + ' #nacionalidad option:selected').html();
  if (valorNacionalidad == '-- Nacionalidad --') valorNacionalidad = '';
  var valorEdad = $(idForm + ' #form_cupon_cupon_edad option:selected').html();
  if (valorEdad == '-- Edad --') valorEdad = '';
  var valorEstudios = $(idForm + ' #estudiosid option:selected').html();
  if (valorEstudios == '-- Nivel de estudios --') valorEstudios = '';

  // Recogemos valor de Nombre, Email, Teléfono y los hasheamos
  var valorNombre = $(idForm + ' #form_cupon_cupon_nombre').val();
  var valorEmail = $(idForm + ' #form_cupon_cupon_email').val();
  var valorTelefono = $(idForm + ' #form_cupon_cupon_telefono').val();
  if(empty(valorEmail)) {
    valorEmail = 'undefined';
    valorHashEmail = 'undefined';
    valorHashStandardEmail = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorEmail,
      success: function(data) {
          data = JSON.parse(data);
          
          valorHashEmail = data.cadena;
      },
      error: function() {
          valorHashEmail = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorEmail,
      success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardEmail = data.cadena;
      },
      error: function() {
          valorHashStandardEmail = 'undefined';
      }
    });
  }
  if(empty(valorTelefono)) {
    valorTelefono = 'undefined';
    valorHashTelefono = 'undefined';
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorTelefono,
      success: function(data) {
          data = JSON.parse(data);
          
          valorHashTelefono = data.cadena;
      },
      error: function() {
          valorHashTelefono = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorTelefono,
      success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardTelefono = data.cadena;
      },
      error: function() {
          valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if(empty(valorCP)) {
    valorCP = 'undefined';
    valorHashCP = 'undefined';
    valorHashStandardCP = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorCP_2 = valorCP;

    if (valorCP_2.includes(" ")) {
      valorCP_2 = valorCP_2.replace(/\s+/g, ""); // Elimina todos los espacios
    }
    if (valorCP_2.includes("-")) {
      valorCP_2 = valorCP_2.replace(/-/g, ""); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHABase64&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashCP = data.cadena;
      },
      error: function() {
        valorHashCP = 'undefined';
      }
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardCP = data.cadena;
      },
      error: function() {
        valorHashStandardCP = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHABase64&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.cadena;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });

      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
      valorHashStandardNombre = 'undefined';
    }

  }

  var valorTransaction = $('#transactionIdWeb').val();

  if (tipoEvento == 0){
    window.dataLayer = window.dataLayer|| [];
    window.dataLayer.push({
    'event': 'form_send',
    'step': '2',
    'formacion': valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
    'categoria': valorCategoria, // Aquí la categoría de la elección anterior. 
    'curso': valorCurso, // Aquí el curso que ha elegido en función de la categoria.
    'pais': valorPais, // Queremos saber de qué país es.
    'provincia': valorProvincia, // Queremos saber de qué provincia es.
    'cp': valorCP, // Queremos saber el código postal.
    'nacionalidad': valorNacionalidad, // Queremos saber de qué nacionalidad es.
    'edad': valorEdad, // Queremos saber la edad escogida. 
    'nivel_estudios': valorEstudios // Queremos el nivel de estudios que ha indicado 
    });
  }else if (tipoEvento == 1){ // view_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
    });
    
  }else if (tipoEvento == 2){ // form_start
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_start",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      form_modality: 'Semipresencial',
    });
    
  }else if (tipoEvento == 3){ // generate_lead
    var valorCursoId = $('#form_cupon_idcurso_real').val();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      edu_pid : valorCursoId,
      form_modality: 'Semipresencial',
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      postal_hash: valorHashCP,
      nombre: valorHashNombre,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad,
      hashed_name_edu: valorHashStandardNombre,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_cp_edu: valorHashStandardCP
    });
    
  }else if (tipoEvento == 4){ // error_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      form_modality: 'Semipresencial',
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_mail_edu: valorHashStandardEmail,
      error_field: errorForm
    });
  }
}

function enviarEventoViewForm(){
  enviarEventoFormulario(1);
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $('#' + form_id + ' #' + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $('#' + form_id + ' #' + telefono).val('');
  inputTelefono.reportValidity();

  return true;
}

// cuando empezamos a escribir en el buscador (quizas con la de abajo, esta seria prescindible)
$('#search-index-input, #search-index-input-mobile').keyup(function () {
  habilitarDeshabilitarBotonBuscar($(this).val());
});

// cuando ponemos el cursor encima del boton buscar
$("#btn-search, #btn-search-sm").on("mouseover", function(){
  habilitarDeshabilitarBotonBuscar();
});

function habilitarDeshabilitarBotonBuscar(campoTexto = '') {


  let searchButton = $('button.btn-search');

  if(campoTexto == '') {
    if($('#search-index-input').length > 0 && $('#search-index-input').val().length > 0) {
      campoTexto = $('#search-index-input').val();
    } 
    if($('#search-index-input-mobile').length > 0 && $('#search-index-input-mobile').val().length > 0) {
      campoTexto = $('#search-index-input-mobile').val();
    } 
  }

  let formularioFiltros = $('#busqueda-avanzada');
  let checkboxesCheckeados = 0;

  formularioFiltros.find('.input-avanzado').each(function(){
    if ($(this).is(':checked')) {
      checkboxesCheckeados++;
    }
  });

  // console.log("checkboxes checkeados "+ checkboxesCheckeados);

  if (campoTexto.length !== 0 || checkboxesCheckeados > 0) {
    searchButton.removeAttr('disabled');
    searchButton.addClass('disable-tooltip'); // Desactivar tooltip para este botón
  } else {
    searchButton.attr('disabled', 'disabled');
    searchButton.removeClass('disable-tooltip'); // Re-activar tooltip para este botón
  }

}

// se usa al buscar en un input text. para que al usuario le de tiempo a escribir
// desde .buscarExamenes. Lo ponemos aqui por si lo volvemos a usar
function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

// traspasamos del util.js

function isMobileResolution() {
  return $(window).width() < 769;
}

// si se usa. Sirve para el chatBot este.
function abrirModalInfoChat(piloto){

  $('.cm-solicita-info-header').click();

}

function _orden(idform, url,orden)
{
  $('#'+idform+' input[name=_orden]').val(orden);
  _pag(idform, url, 1);
}

// creo que no se usa
function _regxpag(idform, url, regxpag)
{
  $('#'+idform+' input[name=_regxpag]').val(parseInt(regxpag));
  _pag(idform, url, 1);
}

function _pag(idform, url, pag)
{
  $('#'+idform).attr('action', url+(pag > 1 ? "/"+pag : '')).submit();
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
      '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
      $(spinnerContenedor).appendTo(elementoContenedor);
      $('.spinner-contenedor').html(htmlSpinner);
  } else {
      $('.spinner-contenedor').remove();
  }
}

function htmlspecialchars(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function datosCurso() {
  // Obtenemos el atributo de categoría para asignarlo en el campo oculto de formulario
  var valorCurso = $('#form_cupon_idcurso option:selected').html();
  var nameCategoria = $('#form_cupon_idcurso option:selected').attr('attr-grupo');

  // Seteamos valores ocultios de formulario
  $('#form_cupon_general_categoria').val(nameCategoria)
  $('#form_cupon_general_curso').val(valorCurso)
}

function restringirCampoNumerico(idCampo, idForm = "#form_cupon ") {
  $(idForm + "#" + idCampo).on("input", function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, "")
        );
      }
    });
  });
}

$(document).on('click', '.solicita-informacion', function (e) {

  var esLlamada = $(this).is('#customEnlaceLlamadaFueraHorario');
  var eventoWeb = $(this).data('evento');

  // alert("ssdssdsd");
  // $('head').append("<link rel='stylesheet' title='cssModalCuponCustom' href='/web/css/dist/cupon-modal.css?v="+cdn_v+"' />");
  // $('body').append(
  //   "<script data-script='cupon-modal' src='" +
  //     rutaweb +
  //     "/web/js/dist/cupon-modal.min.js?v="+cdn_v+"'></script>"
  // );

  cargaModal(e, null, null, eventoWeb, esLlamada);
});

function cargaModal(e = null, categoria = null, curso = null, eventoWeb = undefined, esLlamada = false) {
  if (e && typeof e.stopPropagation === 'function') {
    e.preventDefault();
    e.stopPropagation();
  }

  if(!empty(categoria))
    catCuponPost = categoria;
  else
    catCuponPost = catCupon;

  if(!empty(curso))
    curCuponPost = curso;
  else
    curCuponPost = curCupon;

  if(eventoWeb == undefined)
    eventoWeb = 'Solicita_info';

  // entra en las fichas (cuando ya tiene curso adjudicado)
  if(!empty(curCuponPost)) {
    mostrarOcultarSpinner(true, '.overlay-modal');

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);
                
          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");
    
          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }

          $("#cm-form #datosCupon").html("");

          jQuery.ajax({
            type: "POST",
            async: true,
            url: rutajs + "lib/ajax.php",
            data: 'fn=getCupon&idCursoComercial=' + curCuponPost +
              '&isModal=' +
              '-modal' +
              '&iw=' +
              cdn_idweb +
              '&rcdn=' +
              cdn_rutacdn +
              '&pCupon=' +
              encodeURIComponent(pCupon) +
              '&rw=' +
              cdn_rutaweb +
              '&lang=' +
              idioma_cupon,
            success: function (data) {

              if (data != '') {
                $('#cm-form #datosCupon').append(data);

                $(".slick-form-modal").slick("slickGoTo", 3);
                $(".cm-form-main-wrapper .pasos span").text("2");
                $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
                $("#cm-form").addClass("limit-width");

                if(hideBtnBackModal) {
                  $(".cm-form-main-wrapper .btn-back").hide();
                  $(".cm-form-main-wrapper .button-row").css('display', 'block');
                }

                enviarEvento('#formularioCuponGeneral');
              }

              if(typeof loadRecaptchaLibrary === 'function')
                loadRecaptchaLibrary();
            },
          }).done(function(){
            $("#cm-form").addClass("visible");
            mostrarOcultarSpinner(false, '.overlay-modal');

            setTimeout(function () {
              $('.slick-form-modal').slick('setPosition');
            }, 500);
          });
        }
      },
    })
  } else {
    // cuando tiene que pasar por varios pasos previos
    mostrarOcultarSpinner(true, '#cm-form');

    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);
          
          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");
          $("#cm-form").addClass("visible");
  
          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });
          
          $(".back-1").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 0);
            $("#cm-form").removeClass("limit-width");
          });
          $(".btn-back").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
            $(".cm-form-main-wrapper .pasos span").text("1");
            $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("Infórmate gratis y sin compromiso");
            $("#cm-form").removeClass("limit-width");
          });
  
          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }
        }
      },
    }).done(function(){
      if (aCatCupon != '' && aCatCupon != undefined) {
        $('.selector-modal-categoria').closest('li').hide();
        
        $.each(aCatCupon, function(index, value) {
          $('#categoria-modal-' + value).closest('li').show();
        });
      }
  
      if (catCuponPost != '' && catCuponPost != undefined)
        $('#categoria-modal-' + catCuponPost).click();
    });
  }
}

function cargaCursos(element) {
  var idCategoria = element.data('categoria-id');
  var sNombre = element.data('name');

  if (idCategoria != "") {    
    mostrarOcultarSpinner(true, '#cm-form');

    $("#stepCurso").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursosGrupo&valorCategoria=" + idCategoria,
      success: function (data) {

        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          var html = '';
          var idGrupo = null;
          var nGrupo = "";
          var style = "";
          var currentGroupHtml = "";

          $.each(data.aCursos, function (index, value) {
            var showCourse = (aCurCupon == '' || aCurCupon == undefined || $.inArray(value.idCursoComercial, aCurCupon) !== -1);

            if (showCourse) {
              if (value.idGrupo != idGrupo) {
                if (idGrupo !== null) {
                  html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idGrupo + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
                }
                idGrupo = value.idGrupo;
                nGrupo = (value.sGrupo != undefined) ? value.sGrupo : value.categoriaNombre;
                currentGroupHtml = '';
              }
              currentGroupHtml += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s tipo-formacion-general tipo-formacion-' + value.idGrupo + '" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sTematica + '" onclick="cargaCupon($(this), \'-modal\')" ' + style + '>' + value.sTematica + '</a></li>';
            }
          });

          if (idGrupo !== null) {
            html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idGrupo + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
          }

          $("#stepCurso").html(html);
          $(".step-categoria-nombre").html(sNombre + '<svg class="i"><use xlink:href="#cm-lapiz"></use></svg>');
          $(".slick-form-modal").slick("slickGoTo", 1);
          $("#cm-form").removeClass("limit-width");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
      setTimeout(function () {
        setTimeout(function () {
          if (curCuponPost != "" && curCuponPost != undefined)
            $('#curso-' + curCuponPost).click();
        }, 1000);
      }, 1000);

      mostrarOcultarSpinner(false, '#cm-form');
    });
  }
}

function cargaCupon(element, isModal = '') {
  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#cm-form');

    $("#cm-form #datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {

        if (data != '') {
          $('#cm-form #datosCupon').append(data);
          $(".slick-form-modal").slick("slickGoTo", 3);
          $(".cm-form-main-wrapper .pasos span").text("2");
          $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
          $("#cm-form").addClass("limit-width");

          if(hideBtnBackModal) {
            $(".cm-form-main-wrapper .btn-back").hide();
            $(".cm-form-main-wrapper .button-row").css('display', 'block');
          }

          enviarEvento('#formularioCuponGeneral');
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#cm-form');

      setTimeout(function () {
        $('.slick-form-modal').slick('setPosition');
      }, 500);
    });
  }
}